<template>
    <div id="reproductor-container" class="h-reproductor w-1/2 mx-auto rounded-smoth overflow-hidden flex shadow-menu shadow-black-12 max-md:w-11/12 max-md:h-reproductor-mobile dark:bg-primary-dark-color-4th">
        <div id="reproductor-subcontainer" class="flex w-full max-md:flex-col max-md:py-special">
            <div id="container-img-data" class="h-full flex w-1/2 max-md:w-full max-md:justify-center">
                <div v-if="store.getIsLive()" id="mark" class="w-4 h-4 bg-red-error-text rounded-full absolute right-24.45 top-2 max-md:w-3 max-md:h-3 max-md:right-3">
                    <div class="animate-ping relative w-5 h-5 bg-red-error-text rounded-full right-mark-reproductor-desktop -top-mark-top-reproductor-desktop max-md:w-3 max-md:h-3 max-md:right-0 max-md:top-0"></div>
                </div>
                <div v-if="!store.isMovil" class="h-full w-reproductor rounded-smoth overflow-hidden">
                    <img :src="caratula" alt="" class="w-full h-full object-cover">
                </div>
                <div id="data" class="flex flex-col h-full justify-center pl-special max-md:pl-0 max-md:items-center">
                    <span class="font-bloggerB text-principal-desktop text-secondary-color-3rd max-md:text-principal-mobile dark:text-primary-dark-text">
                        {{ texts[2] }}
                    </span>
                    <span class="font-monserratM text-content-desktop text-gray-text max-md:text-content-mobile">{{ t('slogan') }}</span>
                </div>
            </div>
            <div id="control-radio" class="flex w-1/2 px-special max-md:w-full max-md:justify-center max-md:mt-special">
                <div id="container-buttons-reproductor" class="flex flex-col justify-center items-center h-full max-md:ml-auto w-1/4">
                    <div id="buttons" class="w-10 mb-min">
                        <div id="play-button" v-if="!store.getIsLive()" class="hover:cursor-pointer" @click="storeR.setPlay()">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                                <path class="fill-secondary-color-3rd dark:fill-primary-dark-text" d="M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM188.3 147.1c-7.6 4.2-12.3 12.3-12.3 20.9V344c0 8.7 4.7 16.7 12.3 20.9s16.8 4.1 24.3-.5l144-88c7.1-4.4 11.5-12.1 11.5-20.5s-4.4-16.1-11.5-20.5l-144-88c-7.4-4.5-16.7-4.7-24.3-.5z" />
                            </svg>
                        </div>
                        <div id="pause-button" v-if="store.getIsLive()" class="hover:cursor-pointer" @click="storeR.setPause()">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                                <path class="fill-secondary-color-3rd dark:fill-primary-dark-text" d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM192 160H320c17.7 0 32 14.3 32 32V320c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V192c0-17.7 14.3-32 32-32z" />
                            </svg>
                        </div>
                    </div>
                </div>
                <div id="container-vol" class="w-36 my-auto ml-auto max-md:ml-0 max-md:w-32">
                    <div id="control-volume" class="sticky overflow-hidden w-11 mx-auto px-middle py-min transition-all duration-500 ease-in-out hover:w-32 hover:rounded-full">
                        <div id="control" class="flex w-max h-full items-center relative ">
                            <div id="img-control" class="w-7 relative">
                                <span v-if="vol == 0" id="vol-0">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
                                        <path class="fill-secondary-color-3rd dark:fill-primary-dark-text" d="M301.1 34.8C312.6 40 320 51.4 320 64V448c0 12.6-7.4 24-18.9 29.2s-25 3.1-34.4-5.3L131.8 352H64c-35.3 0-64-28.7-64-64V224c0-35.3 28.7-64 64-64h67.8L266.7 40.1c9.4-8.4 22.9-10.4 34.4-5.3zM425 167l55 55 55-55c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-55 55 55 55c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-55-55-55 55c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l55-55-55-55c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z" />
                                    </svg>
                                </span>
                                <span v-if="vol > 0" id="vol-100">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512">
                                        <path class="fill-secondary-color-3rd dark:fill-primary-dark-text" d="M533.6 32.5C598.5 85.2 640 165.8 640 256s-41.5 170.7-106.4 223.5c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C557.5 398.2 592 331.2 592 256s-34.5-142.2-88.7-186.3c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5zM473.1 107c43.2 35.2 70.9 88.9 70.9 149s-27.7 113.8-70.9 149c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C475.3 341.3 496 301.1 496 256s-20.7-85.3-53.2-111.8c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5zm-60.5 74.5C434.1 199.1 448 225.9 448 256s-13.9 56.9-35.4 74.5c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C393.1 284.4 400 271 400 256s-6.9-28.4-17.7-37.3c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5zM301.1 34.8C312.6 40 320 51.4 320 64V448c0 12.6-7.4 24-18.9 29.2s-25 3.1-34.4-5.3L131.8 352H64c-35.3 0-64-28.7-64-64V224c0-35.3 28.7-64 64-64h67.8L266.7 40.1c9.4-8.4 22.9-10.4 34.4-5.3z" />
                                    </svg>
                                </span>
                            </div>
                            <input type="range" name="volume-range" id="volume" v-model="vol" @input="storeR.setVol(vol)" class="w-16 ml-button relative ">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref } from 'vue';
import { useTranslation } from 'i18next-vue';
import { generalStore } from '@/stores';
import { radioStore } from '@/stores/radio';

const store = generalStore();
const storeR = radioStore();
const { t } = useTranslation();

const props = defineProps([
    'texts',
    'caratula'
])

storeR.setVol(store.getLocalStorage('persistVol'))
if (storeR.getVol() == 0) {
    storeR.setVol(20);
}

var vol = ref(storeR.getVol());

storeR.setPause();
</script>